module.exports = __webpack_public_path__ + "media/images/illustrations/moving_shuttle_van-ed870e545c25012304bf3755d089233e.svg";